import { styled } from '@linaria/react'

export const PopupPortalSC = styled.div``
export const PopupPortalWindow = styled.div``
export const CloseButtonPopup = styled.div``
export const PopupContent = styled.div`
  //display: flex;
  //position: fixed;
  //align-items: center;
  //justify-content: center;
  z-index: 5;
  //width: 70%;
  //height: 70%;
  //display: flex;
  //align-items: center;
  //justify-content: center;
`
